import request from "axios";

/**
 * 获取成本确认汇总列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export const getCostConfirmationList = (params) => {
  return request({
    url: "/lebo-report/financial/incomeOrderCostSummary/aggregate",
    method: "get",
    params
  });
};

/**
 * 导出成本确认汇总列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export const exportCostConfirmationList = (params) => {
  return request({
    url: "/lebo-report/financial/incomeOrderCostSummary/exportExcel",
    method: "get",
    params,
    responseType: 'blob'
  });
};

